/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  GetCommonState400Response,
  GetInstruction404Response,
  GetServices200Response,
  GetServicesCategory200Response,
} from '../models/index'
import {
  GetCommonState400ResponseFromJSON,
  GetCommonState400ResponseToJSON,
  GetInstruction404ResponseFromJSON,
  GetInstruction404ResponseToJSON,
  GetServices200ResponseFromJSON,
  GetServices200ResponseToJSON,
  GetServicesCategory200ResponseFromJSON,
  GetServicesCategory200ResponseToJSON,
} from '../models/index'

export interface GetServicesCategoryRequest {
  serviceCategory: string
}

export interface GetServicesItemRequest {
  serviceCategory: string
  serviceSlug: string
}

/**
 * ServicesApi - interface
 *
 * @export
 * @interface ServicesApiInterface
 */
export interface ServicesApiInterface {
  /**
   * Дерево услуг: корневые категории с вложенными услугами, сортировка по meta.extra.sort_order. Ответ кэшируется в Redis.
   * @summary Дерево услуг
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ServicesApiInterface
   */
  getServicesRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetServices200Response>>

  /**
   * Дерево услуг: корневые категории с вложенными услугами, сортировка по meta.extra.sort_order. Ответ кэшируется в Redis.
   * Дерево услуг
   */
  getServices(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetServices200Response>

  /**
   * Детальная страница категории услуг по slug. Обслуживается универсальным роутом /services/{slug} (резолв по последнему сегменту пути). Ответ кэшируется в Redis.
   * @summary Категория услуг по slug
   * @param {string} serviceCategory Slug категории услуг
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ServicesApiInterface
   */
  getServicesCategoryRaw(
    requestParameters: GetServicesCategoryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetServicesCategory200Response>>

  /**
   * Детальная страница категории услуг по slug. Обслуживается универсальным роутом /services/{slug} (резолв по последнему сегменту пути). Ответ кэшируется в Redis.
   * Категория услуг по slug
   */
  getServicesCategory(
    requestParameters: GetServicesCategoryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetServicesCategory200Response>

  /**
   * Детальная страница услуги по slug. Обслуживается универсальным роутом /services/{slug} (резолв по последнему сегменту пути — serviceSlug). Ответ кэшируется в Redis.
   * @summary Услуга по slug
   * @param {string} serviceCategory Slug категории услуг
   * @param {string} serviceSlug Slug услуги (резолвится по последнему сегменту)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ServicesApiInterface
   */
  getServicesItemRaw(
    requestParameters: GetServicesItemRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetServicesCategory200Response>>

  /**
   * Детальная страница услуги по slug. Обслуживается универсальным роутом /services/{slug} (резолв по последнему сегменту пути — serviceSlug). Ответ кэшируется в Redis.
   * Услуга по slug
   */
  getServicesItem(
    requestParameters: GetServicesItemRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetServicesCategory200Response>
}

/**
 *
 */
export class ServicesApi
  extends runtime.BaseAPI
  implements ServicesApiInterface
{
  /**
   * Дерево услуг: корневые категории с вложенными услугами, сортировка по meta.extra.sort_order. Ответ кэшируется в Redis.
   * Дерево услуг
   */
  async getServicesRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetServices200Response>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/v1/services`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetServices200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Дерево услуг: корневые категории с вложенными услугами, сортировка по meta.extra.sort_order. Ответ кэшируется в Redis.
   * Дерево услуг
   */
  async getServices(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetServices200Response> {
    const response = await this.getServicesRaw(initOverrides)
    return await response.value()
  }

  /**
   * Детальная страница категории услуг по slug. Обслуживается универсальным роутом /services/{slug} (резолв по последнему сегменту пути). Ответ кэшируется в Redis.
   * Категория услуг по slug
   */
  async getServicesCategoryRaw(
    requestParameters: GetServicesCategoryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetServicesCategory200Response>> {
    if (requestParameters['serviceCategory'] == null) {
      throw new runtime.RequiredError(
        'serviceCategory',
        'Required parameter "serviceCategory" was null or undefined when calling getServicesCategory().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/v1/services/{serviceCategory}`.replace(
          `{${'serviceCategory'}}`,
          encodeURIComponent(String(requestParameters['serviceCategory']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetServicesCategory200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Детальная страница категории услуг по slug. Обслуживается универсальным роутом /services/{slug} (резолв по последнему сегменту пути). Ответ кэшируется в Redis.
   * Категория услуг по slug
   */
  async getServicesCategory(
    requestParameters: GetServicesCategoryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetServicesCategory200Response> {
    const response = await this.getServicesCategoryRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Детальная страница услуги по slug. Обслуживается универсальным роутом /services/{slug} (резолв по последнему сегменту пути — serviceSlug). Ответ кэшируется в Redis.
   * Услуга по slug
   */
  async getServicesItemRaw(
    requestParameters: GetServicesItemRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetServicesCategory200Response>> {
    if (requestParameters['serviceCategory'] == null) {
      throw new runtime.RequiredError(
        'serviceCategory',
        'Required parameter "serviceCategory" was null or undefined when calling getServicesItem().'
      )
    }

    if (requestParameters['serviceSlug'] == null) {
      throw new runtime.RequiredError(
        'serviceSlug',
        'Required parameter "serviceSlug" was null or undefined when calling getServicesItem().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/v1/services/{serviceCategory}/{serviceSlug}`
          .replace(
            `{${'serviceCategory'}}`,
            encodeURIComponent(String(requestParameters['serviceCategory']))
          )
          .replace(
            `{${'serviceSlug'}}`,
            encodeURIComponent(String(requestParameters['serviceSlug']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetServicesCategory200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Детальная страница услуги по slug. Обслуживается универсальным роутом /services/{slug} (резолв по последнему сегменту пути — serviceSlug). Ответ кэшируется в Redis.
   * Услуга по slug
   */
  async getServicesItem(
    requestParameters: GetServicesItemRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetServicesCategory200Response> {
    const response = await this.getServicesItemRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }
}
